export const statusPriorities: { [key: number]: { name: string, priority: number } } = {
    0: { name: "Unknown", priority: 15 },
    1: { name: "Failsafe", priority: 1 },
    2: { name: "WaitingForMaterialSetup ", priority: 2 },
    3: { name: "Completed", priority: 5 },
    4: { name: "Paused", priority: 6 },
    5: { name: "PreparingForPrint", priority: 7 },
    6: { name: "Printing", priority: 8 },
    7: { name: "Busy", priority: 10 },
    8: { name: "Idle", priority: 11 },
    9: { name: "Offline", priority: 12 },
    10: { name: "Heating", priority: 9 },
    11: { name: "WaitingForUserAction", priority: 4 },
    12: { name: "Unavailable", priority: 13 },
    13: { name: "Blackout", priority: 3 },
    14: { name: "Initializing", priority: 14 }
}